"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CalculatorButtonGroup = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CalculatorButtonGroup"));

var _EditionSelectionButton = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/EditionSelectionButton"));

var _Editions = require("self-service-api/constants/Editions");

var ALL_EDITIONS = [_Editions.FREE, _Editions.STARTER, _Editions.PROFESSIONAL, _Editions.ENTERPRISE];

var EditionSelectionButtonGroup = function EditionSelectionButtonGroup(_ref) {
  var activeEdition = _ref.activeEdition,
      onEditionUpdated = _ref.onEditionUpdated,
      ownedEdition = _ref.ownedEdition,
      hub = _ref.hub;
  var editionsAlreadyOwned = ownedEdition ? ALL_EDITIONS.slice(0, ALL_EDITIONS.indexOf(ownedEdition)) : [];
  return _react.default.createElement("div", null, _react.default.createElement(_CalculatorButtonGroup.default, null, _react.default.createElement(_EditionSelectionButton.default, {
    key: _Editions.STARTER,
    edition: _Editions.STARTER,
    selected: activeEdition === _Editions.STARTER,
    disabled: editionsAlreadyOwned.includes(_Editions.STARTER),
    onClick: onEditionUpdated,
    currentPlan: ownedEdition === _Editions.STARTER,
    hub: hub
  }), _react.default.createElement(_EditionSelectionButton.default, {
    key: _Editions.PROFESSIONAL,
    edition: _Editions.PROFESSIONAL,
    selected: activeEdition === _Editions.PROFESSIONAL,
    disabled: editionsAlreadyOwned.includes(_Editions.PROFESSIONAL),
    onClick: onEditionUpdated,
    currentPlan: ownedEdition === _Editions.PROFESSIONAL,
    hub: hub
  }), _react.default.createElement(_EditionSelectionButton.default, {
    key: _Editions.ENTERPRISE,
    edition: _Editions.ENTERPRISE,
    selected: activeEdition === _Editions.ENTERPRISE,
    disabled: editionsAlreadyOwned.includes(_Editions.ENTERPRISE),
    onClick: onEditionUpdated,
    currentPlan: ownedEdition === _Editions.ENTERPRISE,
    hub: hub
  })));
};

EditionSelectionButtonGroup.propTypes = {
  activeEdition: _propTypes.default.string.isRequired,
  onEditionUpdated: _propTypes.default.func.isRequired,
  ownedEdition: _propTypes.default.string,
  hub: _propTypes.default.string
};
var _default = EditionSelectionButtonGroup;
exports.default = _default;
module.exports = exports.default;